// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3H43z","inputDescription":"styles_inputDescription__Id-e8"};